import { Typography, Flex } from "antd";
import { TitleCardsList } from "Components/SelectableCard/Title";

const LivingOptions = [
  {
    title: "East",
  },
  {
    title: "West",
  },
  {
    title: "Central",
  },
  {
    title: "Anywhere",
  },
];

export const GeoGraphicalPreference = ({ selectedCard, setSelectedCard }) => {
  const { Title } = Typography;
  return (
    <Flex
      vertical
      justify="flex-start"
      align="flex-start"
      style={{ marginTop: "24px" }}
    >
      <Title style={{ fontSize: "18px" }}>Preferred region</Title>
      <Flex wrap>
        <TitleCardsList
          options={LivingOptions}
          selectedCard={selectedCard}
          setSelectedCard={setSelectedCard}
        />
      </Flex>
    </Flex>
  );
};
